import {
    type FC,
    useState,
    useCallback,
    useRef,
    type CSSProperties,
    type ReactElement,
} from 'react';
import { Spinner } from 'dibs-elements/exports/Spinner';
import classnames from 'classnames';

import { useHoverZoom } from './useHoverZoom';

import styles from './NftPdpZoomModalResponsive.scss';
import layoutStyles from '../NftPdpRespLayout.scss';

export const NftPdpZoomModalResponsive: FC<{
    src?: string;
    alt?: string;
    staticImg?: ReactElement;
}> = ({ src, alt = '', staticImg }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const imgRef = useRef<HTMLImageElement>(null);
    const hoverZoom = useHoverZoom(imgRef, { maxSize: 'MAX_SIZE_CONTAINER_FIT' });
    const [x, y, scale] = hoverZoom.transform || [];
    const cssVars = {
        '--x': x,
        '--y': y,
        '--scale': scale,
    } as CSSProperties;

    const onLoad = useCallback(() => {
        hoverZoom?.handleLoad?.();
        setIsLoaded(true);
    }, [hoverZoom]);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
            <img
                onMouseMove={hoverZoom?.handleMouseMove}
                onClick={hoverZoom?.handleZoom}
                className={classnames(styles.img, {
                    [styles.canZoom]: hoverZoom?.canZoom,
                    [styles.zoomed]: !!hoverZoom?.transform,
                    [styles.isLoading]: !isLoaded,
                })}
                style={cssVars}
                ref={imgRef}
                alt={alt}
                onLoad={onLoad}
                src={src}
                srcSet={undefined /* TODO */}
            />
            {!isLoaded && (
                <div className={classnames(styles.loadingContainer, layoutStyles.media)}>
                    <div className={styles.staticImageContainer}>
                        <div className={styles.blur} />
                        {staticImg && staticImg}
                    </div>
                    <div className={styles.spinnerContainer}>
                        <Spinner black />
                    </div>
                </div>
            )}
        </>
    );
};
